const releasesValidationHR = {
    "add": {
        "releaseName": {
            "required": 'Naziv izdanja je obavezan',
            "length": 'Naziv izdanja mora imati više od 2 i manje od 120 znakova',
            "noForwardSlash": 'Naziv izdanja ne smije sadržavati kosu crtu (/)',
            "matchTrack": 'Za izdanje s jednom pjesmom naziv izdanja treba odgovarati pjesmi.',
            // validCharacters: 'Naziv izdanja može se sastojati samo od slova, brojeva, razmaka i podvlake'
            },
            "releaseVersion": {
                "length": 'Verzija izdanja mora imati više od 2 i manje od 120 znakova',
                "validCharacters": 'Verzija izdanja može se sastojati samo od slova, brojeva, razmaka i podvlake',
                "missingOne": 'Vaše izdanje sadrži samo jednu pjesmu koja nije Original Mix, stoga prilagođeni naziv miksa pjesme mora biti unesen u verziju izdanja.',
                "missingTwo": 'Ako izdanje nudi više sadržaja od standardne verzije ili je to druga verzija već izdanog albuma/izdanja, morate unijeti verziju izdanja.',
                "invalid": 'Za izdanje s jednom pjesmom bez naziva miksa (Original Mix), verzija izdanja treba ostati prazna. Molimo očistite verziju izdanja ili dodajte naziv miksa pjesmi.'
            },
            "releaseLanguage": {
                "required": 'Jezik izdanja je obavezan. Molimo odaberite jezik naziva vašeg izdanja.'
            },
            "releaseEAN_UPC": {
                "required": "EAN / UPC je obavezan.",
                "length": "EAN broj mora imati točno 13 znakova.",
                "isValidEAN": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, unesite ispravan EAN. Ako učitavate stari katalog i EAN nije valjan, molimo kontaktirajte nas."
            },
            "releaseLabel": {
                "required": 'Molimo odaberite vašu etiketu.'
            },
            "releaseCopyright": {
                "required": 'Morate unijeti vlasnika autorskih prava. Obično je to vaša etiketa.'
            },
            "releaseCopyrightYear": {
                "required": 'Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.',
                "regexp": 'Molimo unesite valjanu godinu autorskih prava'
            },
            "releaseCopyrightPublisher": {
                "required": 'Morate unijeti vlasnika izdavačkih prava. Obično je to vaša etiketa.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.',
                "regexp": 'Molimo unesite valjanu godinu autorskih prava'
            },
            "releaseGenre": {
                "required": 'Molimo odaberite žanr vašeg izdanja.'
            },
            "releaseSubGenre": {
                "required": 'Molimo odaberite podžanr vašeg izdanja'
            },
            "releaseCatalogNumber": {
                "required": 'Unesite jedinstveni broj kataloga izdanja.',
                "length": 'Minimalno 4 i maksimalno 16 znakova.',
                "validFormat": 'Molimo unesite broj kategorije bez razmaka, samo VELIKA slova i brojevi. Prva dva znaka moraju biti VELIKA slova. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Dobar i profesionalan opis izdanja može napraviti razliku.',
                "length": 'Opis izdanja mora imati najmanje 100 i najviše 600 znakova.'
            },
            "releaseArtwork": {
                "required": 'Umjetnički rad je obavezan',
                "wrongSpecsAndColor": 'Pogrešne specifikacije slike i format boje. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px, RGB boje, JPG, maksimalna veličina datoteke 4 MB.',
                "wrongColorFormat": 'Pogrešan format boje slike. Naslovnica izdanja mora biti u RGB bojama. JPG, maksimalna veličina datoteke 4 MB.',
                "wrongSpecs": 'Pogrešne specifikacije slike. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px. JPG, maksimalna veličina datoteke 4 MB.',
                "meetsSpecs": 'Slika zadovoljava sve specifikacije.',
                "chooseImage": 'Molimo odaberite sliku',
                "fileTooLarge": 'Odabrana datoteka je veća od 4 MB. Molimo učitajte naslovnicu u 3000x3000 px, JPG, RGB bojama, maksimalna veličina datoteke 4 MB',
                "wrongExtension": 'Pogrešna ekstenzija datoteke. Odabrana datoteka ima ekstenziju ".jpeg". Molimo učitajte naslovnicu u 3000x3000 px, JPG (samo ekstenzija ".jpg"), RGB bojama, maksimalna veličina datoteke 4 MB'
            },
            "releaseTerritories": {
                "required": 'Molimo odaberite teritorije.'
            },
            "atleastOneCountrySelected": {
                "required": 'Molimo odaberite barem jednu državu.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'Izjava o Youtube Content ID-u je obavezna, molimo odaberite jednu od gore navedenih opcija.'
            },
            "originalReleaseDate": {
                "required": 'Molimo odaberite originalni datum izdanja za sve trgovine širom svijeta.'
            },
            "officialReleaseDate": {
                "required": 'Molimo odaberite službeni datum izdanja za sve trgovine širom svijeta.'
            },
            "atleastOneMainArtist": {
                "required": 'Najmanje jedan umjetnik mora biti glavni'
            },
            "featuringArtistMissing": {
                "required": 'Izdanje mora imati navedenog gostujućeg umjetnika u naslovu pravilno dodijeljenog kao gostujućeg umjetnika. Molimo ispravite i ponovno pošaljite.'
            },
            "duplicateArtists": {
                "required": 'Postoje dva ili više umjetnika s istim imenom.'
            },
            "artistName": {
                "required": 'Molimo odaberite umjetnika'
            },
            "artistType": {
                "required": 'Molimo odaberite vrstu umjetnika'
            },
            "trackName": {
                "required": 'Molimo unesite naziv pjesme'
            },
            "trackMixName": {
                "required": 'Molimo unesite naziv miksa',
                "regexp": 'Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake'
            }
    },
    "update": {
        "releaseName": {
            "required": 'Naziv izdanja je obavezan',
            "length": 'Naziv izdanja mora imati više od 2 i manje od 120 znakova',
            "noForwardSlash": 'Naziv izdanja ne smije sadržavati kosu crtu (/)',
            "matchTrack": 'Za izdanje s jednom pjesmom naziv izdanja treba odgovarati pjesmi.',
            "validCharacters": 'Naziv izdanja može se sastojati samo od slova, brojeva, razmaka i podvlake'
        },
        "releaseVersion": {
            "length": 'Verzija izdanja mora imati više od 2 i manje od 120 znakova',
            "validCharacters": 'Verzija izdanja može se sastojati samo od slova, brojeva, razmaka i podvlake',
            "missingOne": 'Vaše izdanje sadrži samo jednu pjesmu koja nije Original Mix, stoga prilagođeni naziv miksa pjesme mora biti unesen u verziju izdanja.',
            "missingTwo": 'Ako izdanje nudi više sadržaja od standardne verzije ili je to druga verzija već izdanog albuma/izdanja, morate unijeti verziju izdanja.',
            "invalid": 'Za izdanje s jednom pjesmom bez naziva miksa (Original Mix), verzija izdanja treba ostati prazna. Molimo očistite verziju izdanja ili dodajte naziv miksa pjesmi.'
        },
        "releaseLanguage": {
            "required": 'Jezik izdanja je obavezan. Molimo odaberite jezik naziva vašeg izdanja.'
        },
        "releaseEAN_UPC": {
            "required": "EAN / UPC je obavezan.",
            "length": "EAN broj mora imati točno 13 znakova.",
            "isValidEAN": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, unesite ispravan EAN. Ako učitavate stari katalog i EAN nije valjan, molimo kontaktirajte nas."
        },
        "releaseLabel": {
            "required": 'Molimo odaberite vašu etiketu.'
        },
        "releaseCopyright": {
            "required": 'Morate odabrati vlasnika autorskih prava. Obično je to vaša etiketa.'
        },
        "releaseCopyrightYear": {
            "required": 'Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.',
            "regexp": 'Molimo unesite valjanu godinu autorskih prava'
        },
        "releaseCopyrightPublisher": {
            "required": 'Morate unijeti vlasnika izdavačkih prava. Obično je to vaša etiketa.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.',
            "regexp": 'Molimo unesite valjanu godinu autorskih prava'
        },
        "releaseGenre": {
            "required": 'Molimo odaberite žanr vašeg izdanja.'
        },
        "releaseSubGenre": {
            "required": 'Molimo odaberite podžanr vašeg izdanja'
        },
        "releaseCatalogNumber": {
            "required": 'Unesite jedinstveni broj kataloga izdanja.',
            "length": 'Minimalno 4 i maksimalno 16 znakova.',
            "validFormat": 'Molimo unesite broj kategorije bez razmaka, samo VELIKA slova i brojevi. Prva dva znaka moraju biti VELIKA slova. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Opis izdanja mora imati najmanje 100 i najviše 600 znakova.'
        },
        "releaseArtwork": {
            "required": 'Umjetnički rad je obavezan',
            "wrongSpecsAndColor": 'Pogrešne specifikacije slike i format boje. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px, RGB boje, JPG, maksimalna veličina datoteke 4 MB.',
            "wrongColorFormat": 'Pogrešan format boje slike. Naslovnica izdanja mora biti u RGB bojama. JPG, maksimalna veličina datoteke 4 MB.',
            "wrongSpecs": 'Pogrešne specifikacije slike. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px. JPG, maksimalna veličina datoteke 4 MB.',
            "meetsSpecs": 'Slika zadovoljava sve specifikacije.',
            "chooseImage": 'Molimo odaberite sliku',
            "fileTooLarge": 'Odabrana datoteka je veća od 4 MB. Molimo učitajte naslovnicu u 3000x3000 px, JPG, RGB bojama, maksimalna veličina datoteke 4 MB',
            "wrongExtension": 'Pogrešna ekstenzija datoteke. Odabrana datoteka ima ekstenziju ".jpeg". Molimo učitajte naslovnicu u 3000x3000 px, JPG (samo ekstenzija ".jpg"), RGB bojama, maksimalna veličina datoteke 4 MB'
        },
        "releaseTerritories": {
            "required": 'Molimo odaberite teritorije.'
        },
        "atleastOneCountrySelected": {
            "required": 'Molimo odaberite barem jednu državu.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'Izjava o Youtube Content ID-u je obavezna, molimo odaberite jednu od gore navedenih opcija.'
        },
        "originalReleaseDate": {
            "required": 'Molimo odaberite originalni datum izdanja za sve trgovine širom svijeta.'
        },
        "officialReleaseDate": {
            "required": 'Molimo odaberite službeni datum izdanja za sve trgovine širom svijeta.'
        },
        "atleastOneMainArtist": {
            "required": 'Najmanje jedan umjetnik mora biti glavni'
        },
        "featuringArtistMissing": {
            "required": 'Izdanje mora imati navedenog gostujućeg umjetnika u naslovu pravilno dodijeljenog kao gostujućeg umjetnika. Molimo ispravite i ponovno pošaljite.'
        },
        "duplicateArtists": {
            "required": 'Postoje dva ili više umjetnika s istim imenom.'
        },
        "artistName": {
            "required": 'Molimo odaberite umjetnika'
        },
        "artistType": {
            "required": 'Molimo odaberite vrstu umjetnika'
        },
        "trackName": {
            "required": 'Molimo unesite naziv pjesme'
        },
        "trackMixName": {
            "required": 'Molimo unesite naziv miksa',
            "regexp": 'Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "Naziv izdanja je obavezan",
            "length": "Naziv izdanja mora imati između 2 i 120 znakova",
            "invalid": "Naziv izdanja ne može sadržavati kosu crtu (/)"
        },
        "releaseVersion": {
            "length": "Verzija izdanja mora imati više od 2 i manje od 120 znakova",
            "regexp": "Verzija izdanja može se sastojati samo od slova, brojeva, razmaka i podvlake",
            "missingOne": "Vaše izdanje sadrži samo jednu pjesmu koja nije Original Mix, stoga prilagođeni naziv miksa pjesme mora biti unesen u verziju izdanja.",
            "missingTwo": "Ako izdanje nudi više sadržaja od standardne verzije ili je to druga verzija već izdanog albuma/izdanja, morate unijeti verziju izdanja.",
            "invalid": "Za izdanje s jednom pjesmom bez naziva miksa (Original Mix), verzija izdanja treba ostati prazna. Molimo očistite verziju izdanja ili dodajte naziv miksa pjesmi."
        },
        "releaseLanguage": {
            "required": "Jezik izdanja je obavezan. Molimo odaberite jezik naziva vašeg izdanja."
        },
        "releaseLabel": {
            "required": "Molimo odaberite vašu etiketu."
        },
        "releaseCopyright": {
            "required": "Morate unijeti vlasnika autorskih prava. Obično je to vaša etiketa."
        },
        "releaseCopyrightYear": {
            "required": "Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.",
            "regexp": "Molimo unesite valjanu godinu autorskih prava"
        },
        "releaseCopyrightPublisher": {
            "required": "Morate unijeti vlasnika izdavačkih prava. Obično je to vaša etiketa."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Molimo unesite godinu autorskih prava u kojoj će ovo izdanje biti (bilo) objavljeno.",
            "regexp": "Molimo unesite valjanu godinu autorskih prava"
        },
        "releaseGenre": {
            "required": "Molimo odaberite žanr vašeg izdanja."
        },
        "releaseSubGenre": {
            "required": "Molimo odaberite podžanr vašeg izdanja."
        },
        "releaseCatalogNumber": {
            "required": "Unesite jedinstveni broj kataloga izdanja.",
            "length": "Minimalno 4 i maksimalno 16 znakova.",
            "regexp": "Molimo unesite broj kategorije bez razmaka, samo VELIKA slova i brojevi. Prva dva znaka moraju biti VELIKA slova. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Opis izdanja mora imati najmanje 100 i najviše 600 znakova."
        },
        "releaseArtwork": {
            "required": "Umjetnički rad je obavezan",
            "invalidDimensionsAndColorFormat": "Pogrešne specifikacije slike i format boje. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px, RGB boje, JPG, maksimalna veličina datoteke 4 MB.",
            "invalidColorFormat": "Pogrešan format boje slike. Naslovnica izdanja mora biti u RGB bojama. JPG, maksimalna veličina datoteke 4 MB.",
            "invalidDimensions": "Pogrešne specifikacije slike. Veličina naslovnice izdanja mora biti točno 3000 x 3000 px. JPG, maksimalna veličina datoteke 4 MB.",
            "valid": "Slika zadovoljava sve specifikacije",
            "choose": "Molimo odaberite sliku",
            "fileSize": "Odabrana datoteka je veća od 4 MB. Molimo učitajte naslovnicu u 3000x3000 px, JPG, RGB bojama, maksimalna veličina datoteke 4 MB",
            "fileExtension": "Pogrešna ekstenzija datoteke. Odabrana datoteka ima '.jpeg' ekstenziju. Molimo učitajte naslovnicu u 3000x3000 px, JPG (samo '.jpg' ekstenzija), RGB bojama, maksimalna veličina datoteke 4 MB'"
        },
        "releaseTerritories": {
            "required": "Molimo odaberite teritorije."
        },
        "atleastOneCountrySelected": {
            "required": "Molimo odaberite barem jednu državu."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "Izjava o Youtube Content ID-u je obavezna, molimo odaberite jednu od gore navedenih opcija."
        },
        "originalReleaseDate": {
            "required": "Molimo odaberite originalni datum izdanja za sve trgovine širom svijeta."
        },
        "officialReleaseDate": {
            "required": "Molimo odaberite službeni datum izdanja za sve trgovine širom svijeta."
        },
        "atleastOneMainArtist": {
            "required": "Najmanje jedan umjetnik mora biti glavni"
        },
        "artistType": {
            "required": "Molimo odaberite vrstu umjetnika"
        },
        "trackName": {
            "required": "Molimo unesite naziv pjesme"
        },
        "trackMixName": {
            "required": "Molimo unesite naziv miksa",
            "regexp": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake"
        }
    }
};

export default releasesValidationHR;